import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const GoalCustom: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                fillRule="evenodd"
                d="M13.457 1.354a.5.5 0 0 0-.707 0l-8.972 8.972a.5.5 0 0 0-.146.353v2.557a.5.5 0 0 0 .5.5h2.556a.5.5 0 0 0 .354-.147l8.972-8.972a.5.5 0 0 0 0-.707l-2.557-2.556ZM3.538 17h12.308v-2H3.538v2Z"
                clipRule="evenodd"
                {...pathProps}
            />
        </IconSVG>
    );
};
